import Modal from "../../tailadmin/components/ui/Modal";
import { ChangeEvent, useEffect, useState } from "react";
import FichaItem from "./FichaItem";
import BottomModal from "../ui/BottomModal";
import { usePrescription } from "../../context/PrescriptionContext";
import InputDefault from "../ui/InputDefault";
import exerciciesModal from "../../services/exercicies";
import { useAuth } from "../../context/AuthContext";
import { Exercise, Prescription, ExerciseInPlan } from "../../types";
import { FiPlus } from "react-icons/fi";

interface FichaModalProps {
  isOpen: boolean;
  data: Prescription | null;
  onBack: () => void;
}

function FichaModel({ isOpen, data, onBack }: FichaModalProps) {
  const [form, setForm] = useState<Partial<Prescription> | null>(null);
  const { getUser } = useAuth();
  const { setExercicie, workout, addExercicie, removeExercicie, updateFicha } =
    usePrescription();

  const [exercicies, setExercicies] = useState<Exercise[]>([]);

  const init = async () => {
    const user = getUser();
    if (user?.id) {
      const result = await exerciciesModal.list_all(String(user.id), 1, 10);
      setExercicies(result);
    }
  };

  const save = () => {
    if (form) {
      updateFicha(form as Prescription);
      onBack();
    }
  };

  const getName = (id: string) => {
    const found = exercicies.find((e) => String(e.id) === id);
    return found?.name || "";
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isOpen && data) {
      setForm({
        ...data,
        name: data.name,
        duration: data.duration,
        intensity: data.intensity,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, workout]);

  if (!form) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onBack}
      title="Ficha de Treino"
      className="!w-full !max-w-4xl"
    >
      {/* BODY */}
      <form
        onSubmit={(e) => e.preventDefault()}
        className="max-h-[70vh] overflow-y-auto space-y-8 p-6"
      >
        {/* ================== INFORMAÇÕES DA FICHA ================== */}
        <div className="rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
          <h3 className="mb-4 text-lg font-semibold text-black dark:text-white">
            Informações da Ficha
          </h3>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <InputDefault
              label="Nome da Ficha"
              id="name"
              name="name"
              type="text"
              value={form.name || ""}
              required
              onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
                setForm({ ...form, [target.name]: target.value })
              }
              placeholder="Treino A - Pernas"
            />

            <InputDefault
              label="Duração"
              id="duration"
              name="duration"
              type="text"
              value={form.duration || ""}
              required
              onChange={({ target }: ChangeEvent<HTMLInputElement>) =>
                setForm({ ...form, [target.name]: target.value })
              }
              placeholder="60 minutos"
            />
          </div>

          {/* Intensidade */}
          <div className="mt-4">
            <label className="mb-2 block text-sm font-medium text-black dark:text-white">
              Intensidade
            </label>
            <select
              name="intensity"
              required
              value={form.intensity || ""}
              onChange={({ target }) =>
                setForm({ ...form, [target.name]: target.value })
              }
              className="w-full rounded border border-stroke bg-transparent px-5 py-3 outline-none transition focus:border-primary dark:border-form-strokedark dark:bg-form-input"
            >
              <option value="" disabled>
                Selecione a intensidade
              </option>
              <option value="Alta">Alta</option>
              <option value="Média">Média</option>
              <option value="Baixa">Baixa</option>
            </select>
          </div>
        </div>

        {/* ================== EXERCÍCIOS ================== */}
        <div className="rounded-sm border border-stroke bg-white p-6 shadow-default dark:border-strokedark dark:bg-boxdark">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="text-lg font-semibold italic text-black dark:text-white">
              Exercícios
            </h3>

            <button
              type="button"
              onClick={addExercicie}
              className="inline-flex items-center gap-2 rounded-md border-2 border-dashed border-primary px-4 py-2 text-sm font-medium text-primary transition hover:bg-primary hover:text-white"
            >
              <FiPlus size={18} />
              Adicionar
            </button>
          </div>

          {form.exercises && form.exercises.length > 0 ? (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {form.exercises.map((exercise: ExerciseInPlan) => (
                <FichaItem
                  key={exercise.mid || exercise.id}
                  data={exercise}
                  nameLabel={getName(String(exercise.id))}
                  onDelete={() => removeExercicie(String(exercise.mid))}
                  onClick={(e) => setExercicie(e as ExerciseInPlan)}
                  label={`Séries: ${exercise.sets} × Repetições: ${exercise.reps}`}
                />
              ))}
            </div>
          ) : (
            <div className="rounded-lg border border-dashed border-stroke py-12 text-center dark:border-strokedark">
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Nenhum exercício adicionado ainda
              </p>
            </div>
          )}
        </div>
      </form>

      {/* FOOTER */}
      <div className="border-t border-stroke bg-white px-6 py-4 dark:border-strokedark dark:bg-boxdark">
        <BottomModal onSave={save} onBack={onBack} id={form.id} />
      </div>
    </Modal>
  );
}

export default FichaModel;
